import React, { FC, memo } from 'react'

import clsxm from '@/utils/clsxm'

import defaultImage from '~/assets/images/empty-state.png'

const EmptyState: FC<{
  img?: string
  title: string
  description: string
  contentWidth?: string
  imgClass?: string
  containerClass?: string
  buttonText?: string
  onClick?: () => void
}> = ({ img, title, description, contentWidth, imgClass, containerClass, buttonText, onClick }) => {
  return (
    <div className={clsxm('flex select-none flex-col justify-center gap-6 text-center lg:gap-10', containerClass)}>
      <div className='flex justify-center'>
        <img
          src={img ? img : defaultImage.src}
          alt='Empty'
          className={clsxm(imgClass)}
        />
      </div>
      <div className={clsxm('w-full space-y-2 lg:w-[670px] lg:space-y-4', contentWidth)}>
        <p className='font-bold lg:text-2xl'>{title}</p>
        <p className='text-xs lg:text-base'>{description}</p>
      </div>

      {buttonText && (
        <button
          className='mx-auto w-fit rounded-[100px] bg-red px-5 py-3 font-work text-base font-bold text-white lg:px-6'
          onClick={onClick}
        >
          {buttonText}
        </button>
      )}
    </div>
  )
}

export default memo(EmptyState)
